// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .idb-approvers-table {
  min-height: 0;
}
::ng-deep .idb-approvers-table > idb-data-table > p-table table {
  min-width: 20rem !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/account-information/account-information-profile-approvers.component.scss"],"names":[],"mappings":"AACI;EACI,aAAA;AAAR;AAIgB;EACI,2BAAA;AAFpB","sourcesContent":["::ng-deep {\r\n    .idb-approvers-table {\r\n        min-height: 0;\r\n\r\n        > idb-data-table {\r\n            > p-table {\r\n                table {\r\n                    min-width: 20rem !important;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
